import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react'

const useAllClassOf = () => {
  const { data, loading, refetch } = useQuery(
    gql`
      query {
        listClassOfByCounselingPlans
      }
    `,
    {
      variables: {},
      fetchPolicy: 'no-cache'
    }
  );

  const dataClassOf = useMemo(() => {
    return data?.listClassOfByCounselingPlans || [];
  }, [data]);

  return { dataClassOf, loading, refetch };
};
export default useAllClassOf;
